// extracted by mini-css-extract-plugin
export default {"Label":"Checkbox_Label__Db1-b","Input":"Checkbox_Input__ssBUI","Text":"Checkbox_Text__ANxOn","Checkbox":"Checkbox_Checkbox__TnpaN","CheckboxLarge":"Checkbox_CheckboxLarge__iYEeh"};